import React from 'react'

import { IconCheckCircle } from 'components/Icons'
import { ProductChecklist } from '..'

export interface PropsProductHistoryCollapse {
  selectedId: string
  historyId: string
  checklist: ProductChecklist[]
}

const TicketProductHistoryCollapse: React.FC<PropsProductHistoryCollapse> = (
  props,
) => {
  const { selectedId, historyId, checklist } = props

  const base = 'f-ticket-product-history-modal'

  if (selectedId !== historyId) {
    return <div />
  }

  return (
    <div>
      {checklist?.map((item, index) => (
        <div
          data-testid={'div-collapsible-row-testid'}
          className={`${base}__collapsible-row`}
          key={`${selectedId}-${index}`}
        >
          <IconCheckCircle
            data-testid={`ticket-product-history-collapse-icon-check-${index}`}
            className={`${base}__icon-check`}
            variants='md'
          />
          <span>{item.name}</span>
        </div>
      ))}
    </div>
  )
}

export default TicketProductHistoryCollapse
